module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAASCAYAAAC5DOVpAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABtSURBVHgB7c3BCYAwDEDRtBM4QkdwJDfQEbqJIzhSwQQ8htYBtEIVKghWvVj6IZcEXgBKucemkhb1xU3JGVu4j42NsLhIR/0Z8nvjh7eHCSDqCIwgqiG5AAqHQ4AM8KTgcTv4GjpA6r6BSv9pBfAnR0LGW6QLAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/img/chevron_down.png
// module id = BLoR
// module chunks = 1